<ng-container
    *ngrxLet="{
        selectedZoneId: selectedZoneId$,
        isInfoShown: isInfoShown$,
        isEnabled: isEnabled$,
        zonesWithInfo: zonesWithInfo$,
        isProcessing: isProcessing$,
        aupEndTime: aupEndTime$,
        airacEndTime: airacEndTime$,
        timeRange: timeRange$,
        isError: isError$,
        rpaDescriptions: rpaDescriptions$,
        dronePointsDetails: dronePointsDetails$,
    } as vm"
>
    <div class="zones-info-container" *ngIf="vm.isEnabled && vm.isInfoShown && !vm.isError">
        <div class="header">
            <h2 class="title">{{ "dtmMapCesium.zoneInfo.titleLabel" | transloco }}</h2>
            <button type="button" class="button-icon" (click)="closeInfo()">
                <dtm-ui-icon name="close" />
            </button>
        </div>
        <div class="zone-data-container scroll-shadows">
            <dtm-ui-loader-container [isShown]="vm.isProcessing">
                <dtm-map-geographical-zones-info-details
                    *ngFor="let zone of vm.zonesWithInfo; let index = index"
                    [zone]="zone"
                    [selectedZoneId]="vm.selectedZoneId"
                    [isOpened]="index === 0"
                    [aupEndTime]="vm.aupEndTime"
                    [airacEndTime]="vm.airacEndTime"
                    [timeRange]="vm.timeRange"
                    [rpaDescription]="vm.rpaDescriptions | invoke : getRpaDescription : zone"
                    (zoneSelectionChange)="zoneSelectionChange.emit($event)"
                />
                <dtm-map-drone-point-details
                    *ngFor="let dronePointDetails of vm.dronePointsDetails; let index = index"
                    [dronePoint]="dronePointDetails"
                    [isOpened]="!vm.zonesWithInfo.length && index === 0"
                />
            </dtm-ui-loader-container>
        </div>
    </div>
</ng-container>
